<template>
  <el-dialog
    :title="$t('affiliateWithdrawal.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
  >
    <div style="text-align:center">
      <p>{{ $t('affiliateWithdrawal.confirmDeleteWithdrawal') }}</p>
    </div>
    <div slot="footer">
      <el-button @click="dialogVisible = false">
        {{ $t('affiliateWithdrawal.cancel') }}
      </el-button>
      <el-button type="primary" @click="handleConfirm">
        {{ $t('affiliateWithdrawal.confirmDelete') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteAffiliateWithdrawal } from '@/api/affiliate/affiliateWithdrawalApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteAffiliateWithdrawal',
  data() {
    return {
      dialogVisible: false,
      form: {
        awId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.form = { ...row }
      this.dialogVisible = true
    },
    async handleConfirm() {
      try {
        this.form.shopId = getShopId()
        await deleteAffiliateWithdrawal(this.form)
        this.$emit('refresh')
        this.dialogVisible = false
        this.$message.success(this.$t('common.operateSuccess'))
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>